var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',_vm._l((1),function(n){return _c('div',{key:n,staticClass:"row-skeleton"},[_vm._m(0,true),_vm._m(1,true)])}),0):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"col"},[_c('span'),_c('div',{staticClass:"title"}),_c('span')])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('span')])
}]

export { render, staticRenderFns }